import { fetchWithRestaurant } from '../utils/apiHelpers';

const JOB_URL = `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/job`;

export const deleteJob = async (jobId, restaurantId = null) => {
  const endpoint = `${JOB_URL}/${jobId}`;
  const options = {
    method: 'DELETE',
  };

  try {
    const response = await fetchWithRestaurant(endpoint, options, restaurantId);
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to delete job');
    }
    return await response.json();
  } catch (error) {
    console.error('Error deleting job:', error);
    throw error;
  }
};

export const createJob = async (jobData, restaurantId = null) => {
  const endpoint = JOB_URL;
  const options = {
    method: 'POST',
    body: JSON.stringify(jobData),
  };

  try {
    const response = await fetchWithRestaurant(endpoint, options, restaurantId);
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to create job');
    }
    return await response.json();
  } catch (error) {
    console.error('Error creating job:', error);
    throw error;
  }
};

export const updateJob = async (jobId, jobData, restaurantId = null) => {
  const endpoint = `${JOB_URL}/${jobId}`;
  const options = {
    method: 'PATCH',
    body: JSON.stringify(jobData),
  };

  try {
    const response = await fetchWithRestaurant(endpoint, options, restaurantId);
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to update job');
    }
    return await response.json();
  } catch (error) {
    console.error('Error updating job:', error);
    throw error;
  }
};

export const getJobs = async (restaurantId = null) => {
  const endpoint = JOB_URL;
  const options = {
    method: 'GET',
  };

  try {
    const response = await fetchWithRestaurant(endpoint, options, restaurantId);
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch jobs');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching jobs:', error);
    throw error;
  }
};
